export const environment = {
  production: false,
  //apiBaseUrl: 'http://192.168.100.231:5000'
  apiBaseUrl: 'https://sidrive.ene-masterclass.com'
};
